import { defaultsDeep, set } from 'lodash';

import {
  REPORT_FREQUENCY_DAILY,
  REPORT_FREQUENCY_MONTHLY,
  REPORT_FREQUENCY_WEEKLY,
} from 'constants/reportFrequency';
import DefaultSurveySettings from 'config/DefaultSurveySettings';

const setReportSettingsTimezone = (surveyData, userTimezone) => {
  [
    REPORT_FREQUENCY_DAILY,
    REPORT_FREQUENCY_MONTHLY,
    REPORT_FREQUENCY_WEEKLY,
  ].map(key =>
    set(DefaultSurveySettings, `reportSettings.${key}.timezone`, userTimezone),
  );

  surveyData.settings = defaultsDeep(
    {},
    surveyData.settings,
    DefaultSurveySettings,
  );

  return surveyData;
};

export { setReportSettingsTimezone };
